import React from "react";
import { DescriptionTittle } from "../buttons/IconButtons";
import SummaryItem from "./SummaryItem";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Details container for a summary recap: an icon column plus a list of plain
 * label/value rows. Shared by every module's SummaryContainerDetails.
 *
 * @param {Object} props
 * @param {Array<{label: string, value: *}>} [props.items=[]] - Rows to render.
 * @param {Function} props.t - Translation function.
 * @param {React.ComponentType} [props.icon=DescriptionTittle] - Avatar icon.
 * @param {String} [props.className=''] - Optional styles
 * * @returns {JSX.Element}
 */
const SummaryDetailsCard = ({ items = [], t, icon: Icon = DescriptionTittle,className='' }) => {

    return (
        <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <Icon width={24} height={24} />
                </div>
            </div>
            <div className={"col-12 col-md-11 row p-0"}>
                <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                    {items.map((item, index) => (
                        <SummaryItem
                            className={className}
                            key={index}
                            label={item.label}
                            value={item.value}
                            t={t}
                        />
                    ))}
                </div>
            </div>
        </div>
    )

}

export default SummaryDetailsCard
